import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const animateTeamMembers = () => {
    const members = document.querySelectorAll(".block-team .member");
    if (!members.length) return;

    ScrollTrigger.batch(members, {
        onEnter: (batch) => {
            gsap.to(batch, {
                y: 0,
                stagger: 0.15,
                duration: 0.6,
                ease: "power2.out"
            });
        },
        start: "top 90%",
        once: true,
    });

    gsap.set(members, { y: 25 });

    members.forEach((el) => {
        const imageWrapper = el.querySelector(".member_image");
        const image = el.querySelector(".member_image img");

        el.addEventListener("mouseenter", () => {
            gsap.to(el, {
                duration: 0.3,
                ease: "power2.out"
            });

            if (imageWrapper) {
                gsap.to(imageWrapper, {
                    duration: 0.3,
                    ease: "power2.out"
                });
            }

            if (image) {
                gsap.to(image, {
                    scale: 1.05,
                    duration: 0.3,
                    ease: "power2.out"
                });
            }
        });

        el.addEventListener("mouseleave", () => {
            gsap.to(el, {
                y: 0,
                duration: 0.3,
                ease: "power2.out"
            });

            if (imageWrapper) {
                gsap.to(imageWrapper, {
                    duration: 0.4,
                    ease: "power2.out"
                });
            }

            if (image) {
                gsap.to(image, {
                    scale: 1,
                    duration: 0.3,
                    ease: "power2.out"
                });
            }
        });
    });
};
